// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"_32bbee5fda--fullscreen--s_6ZN","no-print":"_32bbee5fda--no-print--qAs_d"};